// Настройка для дополенний из предустановленного списка
import PerfectScrollbar from 'perfect-scrollbar';
import { clearspaces, ftrim } from 'mdlib';
import autoText from './config';

/**
 * extra options {
 * 	requireData - убивает надпись если ни один пункт не выббран
 * }
 */

autoText.config.tempaltes.add(
    new autoText.config.tempaltes.Template('custom', {
        loading: () => `<li class="ui-inlst-item">
            Загружаем
        </li>`,
        error: (message) => `<li class="ui-inlst-item">
            ${message}
        </li>`,
        empty: () => `<li class="ui-inlst-item">
            Ничего не найдено
        </li>`,
        ok: (data) => {
            var title = data.name || '';

            return `<li class="ui-inlst-item">
                    ${title}
                </li>`;
        },
        active: (data) => {
            var title = data.name || '';

            return `<li class="ui-inlst-item active">
                    ${title}
                </li>`;
        },
    })
);

// Получение внешнего вида результата (текст)
autoText.config.results.add(
    new autoText.config.results.Template('custom', (opts = {}) => {
        var title = opts.name || '';

        return title;
    })
);

autoText.config.loaders.add(
    new autoText.config.loaders.Loader(
        'custom',
        (at, val, opts = {}, resolve, reject) => {
            var values = opts.values || [];

            return window.setTimeout(() => {
                var str = val.trim();
                var result;

                if (!str) {
                    result = values;
                } else {
                    result = values.filter((data) => {
                        var re;
                        var name = data.name;
                        var escapedStr;

                        if (!name) {
                            return false;
                        }

                        escapedStr = str.replace(
                            /[\[\^\$\.\|\?\*\+\(\)\\]/gi,
                            (symb) => `\\${symb}`
                        );
                        re = new RegExp(
                            `(?![^&;]+;)(?!<[^<>]*)(${escapedStr})(?![^<>]*>)(?![^&;]+;)`,
                            'gi'
                        );

                        return !!re.test(name);
                    });
                }

                resolve(result);
            }, 0);
        },
        (current) => {
            if (!current) {
                return;
            }

            window.clearTimeout(current);
        }
    )
);

autoText.config.eventsCheck
    .add(
        new autoText.config.eventsCheck.Check('custom', 'close', (at) => {
            var requireData = at.options.requireData;

            if (requireData && !at.data()) {
                at.val('');
                at.reset();
                at.select();
            }
        })
    )
    .add(
        new autoText.config.eventsCheck.Check('city', 'select', (at, data) => {
            var result = data;

            if (!result) {
                const query = clearspaces(ftrim(at.val()));

                if (query) {
                    result = at
                        .listData()
                        .find(
                            (value) =>
                                value.name.toLowerCase() === query.toLowerCase()
                        );
                }
            }

            return result || null;
        })
    )
    .add(
        new autoText.config.eventsCheck.Check('custom', 'init', (at) => {
            var list = at.list();
            const perfectSB = new PerfectScrollbar(list.get(0));
            perfectSB.update(list.get(0));
        })
    )
    .add(
        new autoText.config.eventsCheck.Check(
            'custom',
            'afterOpen, loadComplete',
            (at) => {
                var list = at.list();

                window.setTimeout(() => {
                    const perfectSB = new PerfectScrollbar();
                    perfectSB.update(list.get(0));
                }, 100);
            }
        )
    );

export default autoText;
